//保存
export const SAVE = 0;
// 提交
export const SUBMIT = 1;
// 通过
export const PASS = 2;
// 驳回
export const REJECT = 3;

export const AUDIT_STATUS = {
    SAVE: 0,
    SUBMIT: 1,
    PASS: 2,
    REJECT: 3
};
export const AUDIT_STATUS_OPTION = [
    { key: '保存', value: 0 },
    { key: '提交', value: 1 },
    { key: '通过', value: 2 },
    { key: '驳回', value: 3 }
];
export const STATUS_COLORS = {
    [SAVE]: 'black',   
    [SUBMIT]: 'blue',
    [PASS]: 'green',
    [REJECT]: 'red'
};